"use strict";
const Mailbox = (parent, address) => {
  return {
    isMailbox: true,
    send(action, payload, preventDefault = false) {
      return (e) => {
        if (preventDefault) e.preventDefault();
        if (parent.isMailbox) {
          parent.sendPayload([address, [action, payload]]);
        } else {
          parent([action, payload]);
        }
      };
    },
    sendPayload(payload) {
      if (parent.isMailbox) {
        parent.sendPayload([address, payload]);
      } else {
        parent(payload);
      }
    },
    forwardTo(address2, ...localPayload) {
      if (localPayload.length > 0) {
        const parent2 = Mailbox(this, address2);
        const childPayload = localPayload.length === 1 ? localPayload[0] : localPayload;
        return Mailbox(parent2, childPayload);
      } else {
        return Mailbox(this, address2);
      }
    },
    fromAddress(address2) {
      if (address2.length > 1 && _.isArray(_.last(address2))) {
        return this.forwardTo(..._.initial(address2)).fromAddress(_.last(address2));
      } else {
        return this.forwardTo(...address2);
      }
    }
  };
};
export default Mailbox;
